import * as React from "react";
import { Site } from "@/types/sites";
import styles from "./Branding.module.css";
import { CmsImage } from "@/components/common/CmsImage";
import { GeoSelector } from "@/components/common/GeoSelector";
import useFeatureFlag from "src/hooks/useFeatureFlag";

export const Branding = ({ site }: { site: Site }): React.ReactElement => {
    // TODO: when we don't need the feature flag any more, remove this block of code
    const useGeo = useFeatureFlag("ancorisFeatureFlagUseGeo");
    // END TODO

    const licensingAuthorityLogo =
        site?.attributes?.licensingAuthorityLogo?.data?.attributes?.url;

    const getStyles = (styleName: string) => {
        return licensingAuthorityLogo
            ? [
                  styles[styleName],
                  styles[`${styleName}WithLicensingAuthorityLogo`],
              ].join(" ")
            : styles[styleName];
    };
    const primaryLogoClasses = getStyles("primaryLogo");
    const placeHolderClasses = getStyles("placeHolder");

    return (
        <section id="branding" className={styles.branding}>
            {/* The placeholder below allows us to create three sections of equal size (left, centre, right)
                which makes it possible to centre the main logo, but right-align the secondary logo

                The sizes of the images, plus padding, must be less than 320px - which is the minimum screen with we are supporting.
                The main logo should also, ideally, be slightly bigger than the licencing authority logo, so the widths have
                been set to 160px and 130px respectively
                */}
            <div className={placeHolderClasses}></div>
            <div className={primaryLogoClasses}>
                <div className={styles.logoPadding}>
                    <CmsImage
                        cmsMedia={site?.attributes?.logo}
                        desiredHeight={50}
                        maxWidth={160}
                        defaultAlt={site?.attributes?.name}
                        loading="eager"
                    />
                </div>
            </div>
            <div className={styles.secondaryLogo}>
                <div className={styles.logoPadding}>
                    {licensingAuthorityLogo && (
                        <CmsImage
                            cmsMedia={site?.attributes?.licensingAuthorityLogo}
                            desiredHeight={50}
                            maxWidth={130}
                            defaultAlt={"Licensing authority logo"}
                            loading="eager"
                        />
                    )}
                </div>
            </div>
            { useGeo ? <GeoSelector position="relative" /> : null }
        </section>
    );
};
